goog.provide("shadow.js.shim.module$$mui$material$FormControlLabel");
goog.provide("module$shadow_js_shim_module$$mui$material$FormControlLabel");
shadow.js.shim.module$$mui$material$FormControlLabel = shadow.js.nativeProvides["@mui/material/FormControlLabel"] = shadow$bridge("@mui/material/FormControlLabel");
module$shadow_js_shim_module$$mui$material$FormControlLabel.default = shadow.js.shim.module$$mui$material$FormControlLabel;
